import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import {
  Calculator, BookOpen, FlaskConical, Landmark, BookHeart, Languages,
} from "lucide-react";

const ICON = { Calculator, BookOpen, FlaskConical, Landmark, BookHeart, Languages };
const BG = {
  matematik: "bg-blue-50 border-blue-100 hover:border-blue-300",
  turkce: "bg-orange-50 border-orange-100 hover:border-orange-300",
  fen: "bg-green-50 border-green-100 hover:border-green-300",
  inkilap: "bg-yellow-50 border-yellow-100 hover:border-yellow-300",
  din: "bg-purple-50 border-purple-100 hover:border-purple-300",
  ingilizce: "bg-pink-50 border-pink-100 hover:border-pink-300",
};

export default function SubjectsPage() {
  const [subjects, setSubjects] = useState([]);
  useEffect(() => {
    api.get("/curriculum/subjects").then((r) => setSubjects(r.data));
  }, []);

  return (
    <div className="space-y-5 ela-fade-in" data-testid="subjects-page">
      <div>
        <h1 className="font-heading text-3xl font-bold text-slate-900">Dersler</h1>
        <p className="text-slate-500 text-sm mt-1">8. sınıf MEB müfredatı · LGS hazırlık</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {subjects.map((s) => {
          const Icon = ICON[s.icon] || BookOpen;
          return (
            <Link key={s.key} to={`/dersler/${s.key}`}
              data-testid={`subjectspage-card-${s.key}`}
              className={`ela-card-hover rounded-2xl p-5 border transition ${BG[s.key]}`}>
              <Icon className="w-8 h-8 mb-3 text-slate-700" />
              <div className="font-heading font-semibold text-slate-900 text-lg">{s.name}</div>
              <div className="text-xs text-slate-600 mt-1">{s.unit_count} ünite · {s.topic_count} konu</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
